import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { CustomSnackbar } from './components/CustomSnackbar'
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary'
import { MainLayout, ProfileLayout, TestStripLayout } from './components/Layouts'
import { ErrorModal } from './components/Modals'
import { ErrorProvider, useError } from './context/ErrorContext'
import { initializeErrorHandler } from './store/middleware/errorMiddleware'
import { Landing, Main, RedirectMain, VerifyEmail, VerifyOtp, WaterTestHowTo } from './views'
import { UploadManual } from './views/TestStrip/UploadManual/UploadManual'

import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'
import { CommunityPage, InsightsPage, OverviewPage, RecommendationsPage, ResultsPage, UtilityInfoPage } from './views/Profile'
import { AboutHomeWater } from './views/TestStrip/AboutHomeWater'
import { StripVersionDetection } from './views/TestStrip/StripVersionDetection' // TODO: remove when v1 strips are fully phased out // SIPP-642
import { VerifyLayout } from './views/Verify'

const ErrorHandler = () => {
  const { setError } = useError()

  useEffect(() => {
    initializeErrorHandler(setError)
  }, [setError])

  return null
}

function App() {
  useEffect(() => {
    const facebookTrackingId =
      (window.__ENV__ &&
        window.__ENV__?.FACEBOOK_TRACKING_ID !== '__FACEBOOK_TRACKING_ID__' &&
        window.__ENV__?.FACEBOOK_TRACKING_ID) ||
      process.env.REACT_APP_FACEBOOK_TRACKING_ID ||
      ''

    ReactPixel.init(facebookTrackingId)
    ReactPixel.pageView()

    const TRACKING_ID =
      (window.__ENV__ &&
        window.__ENV__?.GTAG_TRACKING_ID !== '__GTAG_TRACKING_ID__' &&
        window.__ENV__?.GTAG_TRACKING_ID) ||
      process.env.REACT_APP_GTAG_TRACKING_ID ||
      ''

    ReactGA.initialize(TRACKING_ID)
  }, [])
  return (
    <ErrorProvider>
      <ErrorBoundary>
        <ErrorHandler />
        <CustomSnackbar />

        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Main />} />
            <Route path={'/u/:id'} element={<RedirectMain />} />
          </Route>
          <Route path="/verify" element={<VerifyLayout />}>
            <Route path="email" element={<VerifyEmail />} />
            <Route path="otp" element={<VerifyOtp />} />
          </Route>
          <Route path="/profile" element={<ProfileLayout />}>
            {/* SIPP-846: land on Recommendations by default — that's the
                marquee tab now, and Overview drops to position #2 in the
                tab nav. */}
            <Route index element={<Navigate to="recommendations" replace />} />
            <Route path="overview" element={<OverviewPage />} />
            <Route path="insights" element={<InsightsPage />} />
            <Route path="recommendations" element={<RecommendationsPage />} />
            <Route path="results" element={<ResultsPage />} />
            <Route path="info" element={<UtilityInfoPage/>}/>
            <Route path="community" element={<CommunityPage/>}/>
          </Route>
          {/*           <Route path="/test-strip" element={<TestStripLayout />}>

            <Route path="steps" element={<WaterTestHowTo />} />
            <Route path="upload" element={<Upload />} />
            <Route path="upload-manual" element={<UploadManual />} />
            <Route path="results/:id" element={<Results />} /> */}
          {/*             <Route path="" element={<VerifySteps/>}>
              <Route path="email" element={<VerifyEmail/>} />
              <Route path="otp" element={<VerifyOtp/>} />
              <Route path="data" element={<UploadManual/>} />
              <Route path="update" element={<UploadManual/>} />
            </Route> */}
          <Route path="/landing" element={<Landing />} />
          <Route path="/how-to" element={<WaterTestHowTo />} />

          <Route path="/test-strip" element={<TestStripLayout />}>
            <Route path="email" element={<VerifyEmail />} />
            <Route path="otp" element={<VerifyOtp />} />
            <Route path="data" element={<AboutHomeWater />} />
            {/* TODO: remove when v1 strips are fully phased out // SIPP-642 */}
            <Route path="strip-version" element={<StripVersionDetection />} />
            <Route path="update" element={<UploadManual />} />
            <Route index path="*" element={<Navigate replace to="/test-strip/data" />} />
          </Route>
        </Routes>
        <ErrorModal />
      </ErrorBoundary>
    </ErrorProvider>
  )
}

export default App
